import { AzureDevOpsProjectField, AzureDevOpsProjectFieldSchema } from "./components/AzureDevOpsProjectField";
import { AzureDevOpsRepoField, AzureDevOpsRepoFieldSchema } from './components/AzureDevOpsRepoField';
import { AzureDevOpsBranchField, AzureDevOpsBranchFieldSchema } from './components/AzureDevOpsBranchField';
import { AzureDevOpsTokenField, AzureDevOpsTokenFieldSchema } from './components/AzureDevOpsTokenField';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { ExtensionDefinition } from "@backstage/frontend-plugin-api";

export const AzureDevOpsProjectFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
    name: 'AzureDevOpsProjectField',
    params: {
        field: async () =>
            createFormField({
              name: 'AzureDevOpsProjectField',
              component: AzureDevOpsProjectField,
              schema: AzureDevOpsProjectFieldSchema,
            }),
    },
});

export const AzureDevOpsRepoFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
    name: 'AzureDevOpsRepoField',
    params: {
        field: async () =>
            createFormField({
              name: 'AzureDevOpsRepoField',
              component: AzureDevOpsRepoField,
              schema: AzureDevOpsRepoFieldSchema,
            }),
    },
});

export const AzureDevOpsBranchFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
    name: 'AzureDevOpsBranchField',
    params: {
        field: async () =>
            createFormField({
              name: 'AzureDevOpsBranchField',
              component: AzureDevOpsBranchField,
              schema: AzureDevOpsBranchFieldSchema,
            }),
    },
});

export const AzureDevOpsTokenFieldExtension: ExtensionDefinition = FormFieldBlueprint.make({
    name: 'AzureDevOpsTokenField',
    params: {
        field: async () =>
            createFormField({
              name: 'AzureDevOpsTokenField',
              component: AzureDevOpsTokenField,
              schema: AzureDevOpsTokenFieldSchema,
            }),
    },
});
